import React from 'react'
import './Footer.css'
import instagram_icon from '../Assets/instagram_icon.png'
import facebook_icon from '../Assets/facebook_icon.png'
import linkedin_icon from '../Assets/linkedin_icon.png'
import footer_logo from '../Assets/logo.png'
import { Link } from 'react-router-dom'

const Footer = () => {

    return (
        <div className='footer' >
            <div className="up">
                
                <div className="left">
                    <img className='footer-logo'  src={footer_logo} alt="" />
                    <h1>Santoshkumar Varma</h1>
                    <h3>Email:- sonicwavesmumbai@gmail.com</h3>
                    <h3>Phone no:- +91 8390030091</h3>
                    <h3>Office:- Mumbai, Maharashtra</h3>

                    <div className="social-link">
                        <h2>Follow Us</h2>
                       <Link to="/" > <img src={instagram_icon} alt="" /></Link>
                       <Link to="/" > <img src={facebook_icon} alt="" /></Link> 
                       <Link to="/" > <img src={linkedin_icon} alt="" /></Link> 
                    </div>
                </div>
                <div className="right">
                    <h1>Links</h1>
                    <ul className='footer-link'>
                        <li> <Link to="/" >Home</Link></li>
                        <li> <Link to="/about">About</Link> </li>
                        <li><Link to="/contact">Contact</Link></li>
                        <li><Link to="/ursa">Ursa</Link></li>
                        <li><Link to="/viviana">Viviana</Link></li>
                        <li><Link to="/hideamic">Hide-a-mic</Link></li>
                        <li ><Link to="/radius">Radius Windshield</Link></li>
                        <li><Link to="/brand">Brands</Link></li>
                        <li><Link to="/accessories">Accessories</Link></li>
                    </ul>
                </div>
            </div>
            <div className="down">
                <hr />
                <p>© 2025 Sonic Waves. All rights reserved.</p>
            </div>
        </div>
    )
}

export default Footer